import styled from 'styled-components';

const MainWrapper = styled.div`
  .ant-layout-content {
    padding: 24px;
    background: #fff;
  }

  .ant-layout-header {
    background: #001640;
  }

  .ant-menu.ant-menu-dark {
    background: #001640;
  }

  .ant-layout-footer {
    background: #001640;
  }

  .ant-layout-footer .ant-menu-horizontal {
    background: #001640;
  }

  .ant-layout-header .ant-menu-item {
    line-height:64px;
  }
  .logo {
    float: left;
    width: 200px;
    height: 60px;
    margin: 2px;
    background: white;
  }
  .ant-row-rtl .logo {
    float: right;
  }
`;

export default MainWrapper;
